module.exports = __webpack_public_path__ + "img/s3show.f7feaba7.png";